import { useLanguage } from "../contexts/LanguageContext";

export default function Terms() {
  const { t } = useLanguage();

  return (
    <main data-testid="terms-page" className="pt-28 pb-24 bg-[#0a0f1f]">
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
        <h1 className="font-playfair text-4xl md:text-5xl text-[#f8f9fa] tracking-tight mb-12">
          {t("terms.title")}
        </h1>

        <div className="prose-dark font-outfit text-[#94a3b8] leading-relaxed space-y-8 text-sm md:text-base">
          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">1. Información General</h2>
            <p>El presente documento establece las condiciones generales de uso del sitio web medsim.es (en adelante, el "Sitio Web"), propiedad de Sitayag SLU.</p>
            <p>
              <strong className="text-[#f8f9fa]">Titular:</strong> Sitayag SLU<br />
              <strong className="text-[#f8f9fa]">CIF:</strong> B45807344<br />
              <strong className="text-[#f8f9fa]">Domicilio:</strong> Plaza Grecia 1, Primera planta, Oficina 1, 45005 Toledo, Castilla-La Mancha, España<br />
              <strong className="text-[#f8f9fa]">Correo electrónico:</strong> info@sitayag.com<br />
              <strong className="text-[#f8f9fa]">Dominio:</strong> medsim.es
            </p>
            <p>El acceso y uso del Sitio Web implica la aceptación expresa y sin reservas de todas y cada una de las disposiciones incluidas en estos Términos de Servicio.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">2. Objeto</h2>
            <p>El Sitio Web proporciona información sobre MedSim, un simulador de gestión hospitalaria diseñado para la formación de ejecutivos. A través de la plataforma, se ofrecen servicios de simulación empresarial con fines educativos y de formación profesional.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">3. Condiciones de acceso y uso</h2>
            <p>El acceso al Sitio Web es libre y gratuito. El usuario se compromete a:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Hacer un uso correcto y lícito del Sitio Web, de conformidad con la legislación vigente, la moral, las buenas costumbres y el orden público.</li>
              <li>No realizar actividades que puedan ser ilícitas o lesivas de los derechos de terceros.</li>
              <li>No introducir virus informáticos, archivos defectuosos o cualquier otro software que pueda causar daños en los equipos informáticos del Sitio Web o de terceros.</li>
              <li>No intentar acceder a áreas restringidas del Sitio Web sin autorización.</li>
              <li>No utilizar el Sitio Web con fines comerciales no autorizados.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">4. Propiedad Intelectual e Industrial</h2>
            <p>Todos los contenidos del Sitio Web, incluyendo a título enunciativo pero no limitativo, textos, fotografías, gráficos, imágenes, iconos, logotipos, marcas, tecnología, software, diseño gráfico y códigos fuente, son propiedad de Sitayag SLU o de sus licenciantes, y están protegidos por las normas nacionales e internacionales de propiedad intelectual e industrial.</p>
            <p>Queda expresamente prohibida la reproducción, distribución, comunicación pública o transformación de cualquier contenido del Sitio Web sin la autorización expresa y por escrito de Sitayag SLU.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">5. Exclusión de responsabilidad</h2>
            <p>Sitayag SLU no se hace responsable de:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>La continuidad y disponibilidad de los contenidos y servicios del Sitio Web.</li>
              <li>Los errores en los contenidos o la falta de actualización de los mismos.</li>
              <li>La presencia de virus o cualquier otro componente dañino.</li>
              <li>Los daños derivados del uso inadecuado del Sitio Web por parte de los usuarios.</li>
              <li>Los contenidos de sitios web de terceros a los que se pueda acceder a través de enlaces desde el Sitio Web.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">6. Protección de Datos</h2>
            <p>El tratamiento de los datos personales de los usuarios se rige por nuestra Política de Privacidad, que forma parte integrante de los presentes Términos de Servicio. Le recomendamos su lectura antes de facilitarnos sus datos personales a través del formulario de contacto.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">7. Cookies</h2>
            <p>El Sitio Web utiliza cookies conforme a lo dispuesto en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE). El usuario puede aceptar o rechazar el uso de cookies a través del banner que se muestra en la primera visita al Sitio Web.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">8. Modificación de los Términos</h2>
            <p>Sitayag SLU se reserva el derecho de modificar en cualquier momento los presentes Términos de Servicio. Las modificaciones entrarán en vigor desde el momento de su publicación en el Sitio Web. El uso continuado del Sitio Web tras la publicación de las modificaciones implicará la aceptación de las mismas.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">9. Enlaces externos</h2>
            <p>El Sitio Web puede contener enlaces a sitios web de terceros. Sitayag SLU no se responsabiliza del contenido, políticas de privacidad ni prácticas de dichos sitios web externos. Se recomienda al usuario revisar las condiciones de uso y políticas de privacidad de cualquier sitio web externo al que acceda.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">10. Legislación aplicable y jurisdicción</h2>
            <p>Los presentes Términos de Servicio se rigen por la legislación española. Para la resolución de cualquier conflicto que pudiera derivarse del acceso o uso del Sitio Web, las partes se someten a la jurisdicción de los Juzgados y Tribunales de la ciudad correspondiente al domicilio de Sitayag SLU, salvo que la normativa vigente establezca un fuero diferente.</p>
            <p>Legislación aplicable:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo (RGPD)</li>
              <li>Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPD-GDD)</li>
              <li>Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE)</li>
              <li>Real Decreto Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el texto refundido de la Ley General para la Defensa de los Consumidores y Usuarios</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">11. Resolución de litigios en línea</h2>
            <p>De conformidad con el Reglamento (UE) n.º 524/2013 del Parlamento Europeo y del Consejo, se informa de que la Comisión Europea habilitó una plataforma de resolución de litigios en línea (plataforma ODR), accesible en la siguiente dirección:</p>
            <p className="mt-4">
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#1a6cf5] hover:underline">https://ec.europa.eu/consumers/odr</a>
            </p>
            <p className="mt-4">Se recomienda al usuario verificar la disponibilidad y operatividad actual de dicha plataforma, ya que su estado puede haber cambiado desde la publicación de estos Términos.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">12. Contacto</h2>
            <p>Para cualquier consulta relacionada con estos Términos de Servicio, puede contactar con nosotros a través del correo electrónico <a href="mailto:info@sitayag.com" className="text-[#1a6cf5] hover:underline">info@sitayag.com</a>.</p>
          </section>

          <p className="text-[#64748b] text-xs mt-12">Última actualización: Junio 2026</p>
        </div>
      </div>
    </main>
  );
}
